/* eslint-disable react/no-string-refs */
import * as React from 'react'
import {TInput as WizardTextInput} from 'src/components/atoms/input/TextInput'

interface Props {
  onChange: any
  googlemaps: any
  style?: any
  onFocus?: () => void
  onBlur?: () => void
  searchRestrictions?: any
  value?: any
}

export class GoogleMapSearchBox extends React.Component<Props> {
  searchBox = null

  componentDidMount() {
    const { googlemaps, searchRestrictions } = this.props
    const options = {
      componentRestrictions: { country: 'at' },
      ...searchRestrictions
    }
    this.searchBox = new googlemaps.places.Autocomplete(
      this.refs.inputFuneralLocation,
      options
    )
    this.searchBox.setFields([
      'address_components',
      'geometry',
      'name',
      'formatted_address'
    ])
    this.searchBox.addListener('place_changed', this.handleSelect)
  }

  componentWillUnmount() {
    const { googlemaps } = this.props
    googlemaps.event.clearInstanceListeners(this.searchBox)
  }

  handleSelect = () => {
    const { onChange } = this.props
    const place = this.searchBox.getPlace()
    if (place.geometry) onChange(place)
  }

  render() {
    const { style } = this.props
    return (
      <WizardTextInput
        name='maps_search'
        style={style || { padding: '10px', marginLeft: 0, marginRight: 0 }}
        ref='inputFuneralLocation'
        placeholder='Ort suchen'
        {...this.props}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/molecules/configurator/GoogleMapSearchBox.tsx